import script from "./PinnedStat.vue?vue&type=script&lang=ts&setup=true"
export * from "./PinnedStat.vue?vue&type=script&lang=ts&setup=true"

import "./PinnedStat.vue?vue&type=style&index=0&id=14d4f3dc&lang=postcss&scoped=true"

import exportComponent from "/home/deployment/actions-runner/_work/pwscorecards-vue/pwscorecards-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14d4f3dc"]])

export default __exports__